module.exports = __webpack_public_path__ + "img/feature_4.687c9f41.jpg";